"use client"

import { Header } from "@/components/header"
import { MobileAppHeader } from "@/components/mobile-app-header"
import { usePathname } from "next/navigation"
import { usePlatform } from "@/hooks/use-platform"

export function ConditionalHeader() {
  const pathname = usePathname()
  const { isMobile, isLoaded } = usePlatform()

  // Don't render anything until platform is detected to avoid header flickering
  if (!isLoaded) return null

  // Header visibility logic:
  // On Desktop: Always show header except on landing page and auth/admin pages
  // On Mobile: Show the new MobileAppHeader on app pages, hide global header
  const isAppPage = 
    pathname === "/home" || 
    pathname === "/explore" || 
    pathname === "/map" || 
    pathname === "/messages" || 
    pathname === "/profile" || 
    pathname === "/notifications" || 
    pathname === "/settings" || 
    pathname.startsWith("/user/") ||
    pathname.startsWith("/spot/")

  // On Mobile, we show the specialized app header
  if (isMobile) {
    // Only show on actual app content pages
    if (isAppPage) {
      return <MobileAppHeader />
    }
    return null
  }

  const shouldHideDesktopHeader = pathname === "/" || pathname.startsWith("/admin") || pathname.startsWith("/auth")

  if (shouldHideDesktopHeader) {
    return null
  }

  return <Header />
}
